export default {
  infoMessage: `<p><strong>En savoir plus</strong> : Le profil investisseur retenu est « Sécuritaire » par défaut. Ce profil peut être modifié ultérieurement pour ce conseil.</p>
    <p>Le niveau de connaissance et expérience retenu est :</p>
    <ul class="list-disc">
      <li>celui du moins sachant dans le cas de l'administration légale conjointe et lorsque les deux représentants légaux sont présents ;</li>
      <li>débutant (A) dans le cas de l'administration légale conjointe et lorsque un des deux représentants légaux est absent ;</li>
      <li>celui du représentant légal dans le cas de l'administration légale unique.</li>
    </ul>`
}
